export default __webpack_public_path__ + "img/browser/chrome.png";